import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useCurrentPage } from '../../../../hooks/useCurrentPage'
import { PaginatedTableItem } from '../../../../types/table'

export const FW_VISIT_STORAGE_KEY = 'factorial:visitFwFrom'

const PAYROLL_SOURCE = 'fw-payroll-tab'
const AGREEMENT_SOURCE = 'fw-agreements-tab'
const UNTRACKED_SOURCE = 'untracked'

export const useVisitTracking = ({
  loading,
  items,
}: {
  loading: boolean
  items: PaginatedTableItem[]
}) => {
  const [fromSource, setFromSource] = useLocalStorage<string | undefined>(FW_VISIT_STORAGE_KEY)
  const [isLoaded, setIsLoaded] = useState(false)
  const currentPage = useCurrentPage()
  const { navigation } = useNavigation()

  const isPayrollPage = currentPage === navigation.finance.financial_workspace.payroll.path

  const trackEvent = () => {
    if (isPayrollPage) {
      return trackingEvents.accounting.newFinancialWorkspace.visitPayroll
    }

    return trackingEvents.accounting.newFinancialWorkspace.visitGrossSalary
  }

  const currentFwPage = () => {
    if (isPayrollPage) {
      return PAYROLL_SOURCE
    }

    return AGREEMENT_SOURCE
  }

  useEffect(() => {
    if (isLoaded) return

    if (!loading) setIsLoaded(true)
  }, [isLoaded, loading])

  useEffect(() => {
    const tracking = async () => {
      if (isLoaded) {
        const currentSource = fromSource || UNTRACKED_SOURCE

        await track(trackEvent(), {
          source: currentSource,
          data: !!items.length,
        })

        setFromSource(currentFwPage())
      }
    }

    tracking()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded])
}
